import React from 'react';

import { TextBox } from '@ecp/common/src/text/TextBox';

import {
  SkypassFooterNoticeContainer,
  SkypassFooterSubNoticeContainer,
  StyledFooterNoticeAtag,
  StyledFooterNoticeTextBox,
  TextBold,
} from '@ecp/fo/sites/skypass/styles/footer/SkypassFooterBottomStyles';
import { Spacing } from '@ecp/common/src/layouts/Spacing';

export default function SkypassFooterNotice() {
  return (
    <SkypassFooterNoticeContainer>
      <Spacing top={'36px'}/>
      <TextBox size={'28px'} weight={'500'} height={'45px'}>
        알아두세요
      </TextBox>
      <Spacing top={'8px'}/>
      <SkypassFooterSubNoticeContainer>
        <StyledFooterNoticeTextBox size={'16px'}>
          <TextBold>•</TextBold>구매 전 보유 마일리지를 확인해주시기 바랍니다.{' '}
          <StyledFooterNoticeAtag
            target="_blank"
            title="새 창 열림"
            rel="noreferrer"
            weight={'500'}
            href="https://www.koreanair.com/my-mileage/overview"
            style={{ textDecoration: 'underline' }}
          >
            마일리지 현황&gt;
          </StyledFooterNoticeAtag>
        </StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox><TextBold>•</TextBold>대한항공 홈페이지 회원 가입 및 로그인 후 이용 가능합니다.</StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox><TextBold>•</TextBold>본인의 보유 마일리지만 사용할 수 있으며, 가족합산은 불가합니다.</StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox><TextBold>•</TextBold>상품 구매취소나 환불 시, 유효기간이 지난 마일리지는 소멸되어 환급되지 않습니다.</StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox><TextBold>•</TextBold>준비된 수량이 모두 판매되면 안내된 기간 전에 종료될 수 있습니다.</StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox><TextBold>•</TextBold>자세한 내용은 상품 상세 페이지를 참고해주세요.</StyledFooterNoticeTextBox>
      </SkypassFooterSubNoticeContainer>
    </SkypassFooterNoticeContainer>
  );
}
